import { Spinner, Text } from '@/ui-kit'
import { OverlayScrollBars } from '@/ui-kit/components/OverlayScrollbars'
import { Trans } from '@lingui/react/macro'
import { clsx } from 'clsx'
import { WorkerBase } from '../../api/models'
import { DevicesListProps } from './DevicesList'
import styles from './DevicesTable.module.css'

export const DevicesTable = <T extends WorkerBase>({
  columns,
  workers = [],
  selectedWorkerId,
  setSelectedWorkerId,
  meta
}: DevicesListProps<T>) => {
  return (
    <OverlayScrollBars>
      {!!workers.length && (
        <table className={clsx(styles.table, 'max-mobile:mt-1 table w-full min-w-[500px] table-auto')}>
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column.name} className={styles.th}>
                  <Text className="text-gray-90 whitespace-nowrap">{column.name}</Text>
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="pt-5">
            {workers.map((worker) => (
              <tr
                key={worker.id}
                className={clsx(
                  styles.row,
                  !meta?.noHover && styles.rowHover,
                  worker.id === selectedWorkerId && styles.active
                )}
                onClick={() => setSelectedWorkerId?.(worker.id)}
              >
                {columns.map((column) => (
                  <td key={`${worker.id}_${column.name}`} className={clsx(styles.cell, column.cellClassName)}>
                    <Text>{column.value(worker)}</Text>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {workers === undefined ? (
        <Spinner className="mx-auto mt-4 mb-2" />
      ) : (
        !workers.length && (
          <div className="m-auto max-w-[350px] rounded-xl bg-[var(--color-gray-100)] p-6 text-center">
            <Text>{meta?.placeholderText ?? <Trans>No data available yet</Trans>}</Text>
          </div>
        )
      )}
    </OverlayScrollBars>
  )
}
